// import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import { env } from "./EnvironmentConfig";
// import { CHANGE_LOCALE } from "../redux/constants/Theme";

export const APP_NAME = "eContract";
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const APP_PREFIX_PATH = "/app";
export const AUTH_PREFIX_PATH = "/auth";
export const OTP_PREFIX_PATH = "/otp";

export const THEME_CONFIG = {
  navCollapsed: false,
  // sideNavTheme: SIDE_NAV_LIGHT,
  // locale: localStorage.getItem(CHANGE_LOCALE) ?? "en",
  // navType: NAV_TYPE_SIDE,
  topNavColor: "#3e82f7",
  headerNavColor: "",
  mobileNav: false,
  currentTheme: "light",
};
